export default {
  title: 'ブランド設定',
  basicInfo: '基本情報',
};
